import { createEvent, createStore, sample } from 'effector'
import { readonly } from 'patronum'
import { model as router } from '~/core/router'
import { model as signInModel } from '~/features/subscriber/sign-in'
import { T } from '~/shared/helpers'

export const init = createEvent()

export const changeCredentials = createEvent()
export const tryAgain = createEvent()

const $state = readonly(signInModel.$showSubscriptionErrorMessage)

export const $header = $state.map((state) => state?.header ?? null)
export const $subject = $state.map((state) => state?.subject ?? null)
export const $message = $state.map((state) => state?.message ?? null)

export const $pendingTryAgain = createStore(false).on(tryAgain, T).reset(init)

// on refresh or direct access - redirect to sign-in page
sample({
  clock: init,
  source: $state,
  filter: (msg) => msg == null,
  fn: () => '/sign-in',
  target: router.navigateReplace,
})

// on "change credentials" click - redirect to sign-in page
sample({
  clock: changeCredentials,
  fn: () => '/sign-in',
  target: router.navigateReplace,
})

// on "try again" click - try to sign-in with previous credentials
sample({
  clock: tryAgain,
  source: $state,
  filter: Boolean,
  target: signInModel.signInFx,
})
